import React from 'react';

const MaintenancePage = ({ message }) => {
  return (
    <div style={styles.root} data-testid="maintenance-page">
      <div style={styles.card}>
        <div style={styles.iconWrap}>
          <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="#f59e0b" strokeWidth="1.5">
            <path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z" />
          </svg>
        </div>
        <h1 style={styles.title}>Under Maintenance</h1>
        <p style={styles.message}>{message || "We're currently performing scheduled maintenance. We'll be back shortly!"}</p>
        <div style={styles.divider} />
        <div style={styles.footer}>
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#94a3b8" strokeWidth="2"><path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/></svg>
          <span style={styles.brand}>Benz Eatery</span>
        </div>
      </div>
    </div>
  );
};

const styles = {
  root: {
    minHeight: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: '#0f172a',
    padding: 24,
    fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
  },
  card: {
    background: '#1e293b',
    borderRadius: 24,
    padding: '48px 40px',
    maxWidth: 480,
    width: '100%',
    textAlign: 'center',
    border: '1px solid #334155',
  },
  iconWrap: {
    width: 80,
    height: 80,
    borderRadius: 20,
    background: '#fef3c720',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    margin: '0 auto 24px',
  },
  title: {
    fontSize: 28,
    fontWeight: 800,
    color: '#f8fafc',
    margin: '0 0 12px',
    letterSpacing: -0.5,
  },
  message: {
    fontSize: 15,
    color: '#94a3b8',
    lineHeight: 1.7,
    margin: '0 0 28px',
  },
  divider: {
    height: 1,
    background: '#334155',
    margin: '0 0 20px',
  },
  footer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 8,
  },
  brand: {
    fontSize: 13,
    fontWeight: 700,
    color: '#64748b',
  },
};

export default MaintenancePage;
